import assign from 'lodash/assign';

import Address from '../../models/Address';
import type { AllActionTypes } from '../constants';
import constants from '../constants';

export type State = Address;

export type Actions = { type: AllActionTypes; payload: Address };

const initialState: State = new Address();

const address = (state: State = initialState, action: Actions): State => {
  const { type, payload } = action;

  if (type === constants.SET_ADDRESS) {
    return assign({}, state, payload);
  }
  return state;
};

export default address;
